import { useReportWebVitals } from 'next/web-vitals'

import { trackEvent } from 'lib/util/analytics'

type WebVitalMetric = {
  name: string
  value: number
  delta: number
  id: string
  rating: 'good' | 'needs-improvement' | 'poor'
}

const WEB_VITAL_NAMES = new Set(['LCP', 'INP', 'CLS', 'FCP', 'TTFB'])

export function sendWebVital(metric: WebVitalMetric): void {
  const { name, value, delta, id, rating } = metric
  if (!WEB_VITAL_NAMES.has(name)) return

  trackEvent(name, {
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    metric_value: value,
    metric_delta: delta,
    metric_rating: rating,
    metric_id: id,
  })
}

export function WebVitals(): null {
  useReportWebVitals(sendWebVital)
  return null
}
